import React from 'react';
import { Link } from 'react-router-dom';
import { ChapterLabel } from '../ui/ChapterLabel';
import '../../styles/home.css';

const PREVIEWS = [
  {
    glyph: '◎',
    tag: 'Grátis',
    title: 'Mapa Astral',
    text: 'Seu DNA astrológico: Sol, Lua, Ascendente e as casas da sua vida, calculados a partir do seu nascimento.',
    go: 'Descobrir meu mapa →',
    to: '/chart',
  },
  {
    glyph: '♡',
    tag: 'Grátis',
    title: 'Sinastria',
    text: 'Sua afinidade astrológica no amor, com amigos e família — cruzamos seu mapa com o da outra pessoa.',
    go: 'Conferir compatibilidade →',
    to: '/compatibility',
  },
  {
    glyph: '≈',
    tag: 'Grátis',
    title: 'Biorritmo',
    text: 'Seus ciclos físico, emocional e intelectual do dia — para decidir com o corpo a seu favor.',
    go: 'Ver meu dia →',
    to: '/biorritmo',
  },
  {
    glyph: '☾',
    tag: 'Grátis',
    title: 'Ciclo Lunar',
    text: 'Que fase da Lua você vive agora e como navegar cada lunação com a agenda lunar.',
    go: 'Consultar a Lua →',
    to: '/lunar',
  },
  {
    glyph: '✦',
    tag: 'Prévia',
    title: 'Tarot do Dia',
    text: 'Uma carta, um recado. Puxada por Stela com a leitura do seu mapa em vista.',
    go: 'Puxar minha carta →',
    to: '/tarot',
  },
  {
    glyph: '✧',
    tag: 'Stela',
    title: 'Conversa com Stela',
    text: 'Sua sensitiva astróloga: interpreta seu mapa, responde o que você está vivendo e mostra caminhos.',
    go: 'Falar com Stela →',
    to: '/chat',
  },
];

export const Previews: React.FC = () => {
  return (
    <section id="previas" className="previas">
      <div className="reveal" data-reveal>
        <ChapterLabel>FERRAMENTAS · O CÉU DE HOJE</ChapterLabel>
      </div>
      <h2 className="display">
        Ferramentas de autoconhecimento
      </h2>
      <p style={{ color: 'var(--muted)', marginTop: 6 }}>
        Comece por uma prévia gratuita — cada ferramenta revela o suficiente para você decidir se quer ir fundo.
      </p>

      <div className="previa-grid">
        {PREVIEWS.map((preview) => (
          <Link key={preview.title} to={preview.to} className="previa">
            <span className="glyph">{preview.glyph}</span>
            <span className="tag">{preview.tag}</span>
            <h3>{preview.title}</h3>
            <p>{preview.text}</p>
            <span className="go">{preview.go}</span>
          </Link>
        ))}
      </div>
    </section>
  );
};